import _classCallCheck from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classPrivateFieldInitSpec from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _classPrivateFieldGet from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.weak-map.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { AccountStorage } from "./account.storage";
var _accountStorage = /*#__PURE__*/new WeakMap();
export var Account = /*#__PURE__*/function () {
  function Account() {
    _classCallCheck(this, Account);
    _classPrivateFieldInitSpec(this, _accountStorage, new AccountStorage());
  }
  return _createClass(Account, [{
    key: "isLogined",
    value: function isLogined() {
      var login = _classPrivateFieldGet(_accountStorage, this).getCacheAccessToken();
      if (login) {
        return true;
      }
      return false;
    }
  }]);
}();